<div class="flex flex-row justify-center items-center">

  <div class="flex flex-row justify-around items-center"
    *ngIf="error() as err">

    <span>{{err}}</span>

    <button type="button"
      (click)="tryAgain()"
      mat-raised-button>Try Again</button>

  </div>

</div>
